import { Layout, theme } from "antd";
import React, { useState, useMemo } from "react";
import { Route, Routes } from "react-router-dom";
import Error404 from "../pages/errors/Error404";
import MobileMenuDrawer from "./MobileMenuDrawer";
import Top from "./Top";
import routes, { AppRoute } from "./routes";
import AdminProfile from "../pages/Profile";
import SidebarMenu from "./SidebarMenu";
import { Link } from "react-router-dom";
import UserDetails from "../pages/users/UserDetails";
import CreateAccountantFrom from "../pages/accountant/CreateAccountantFrom";
import AccountDetails from "../pages/accountant/AccountDetails";
import ConsultationDetails from "../pages/consultation/ConsultationDetails";
import CreateFormFields from "../pages/dynamic-form/CreateFormFields";
import DocumentDetails from "../pages/documents/DocumentsDetails";
import SubAdminForm from "../pages/subAdmin/SubAdminForm";
import { checkRightAccess } from "../../lib/utils";
import { useAuthStore } from "../../store/slices/user";
import NotificationTable from "../pages/notification/NotificationList"
import BucketDetails from "../pages/filling-management/BucketDetails";

// -------------------- FLATTEN ROUTES --------------------
const newRoutes: AppRoute[] = [];

function convertMultiToSingle(arr: AppRoute[], prevBaseUrl: string = ""): void {
  arr.forEach((v) => {
    if (v.children) {
      convertMultiToSingle(v.children, prevBaseUrl + v.url);
    } else if (!v.ignore) {
      newRoutes.push({ ...v, url: prevBaseUrl + v.url });
    }
  });
}

convertMultiToSingle([...routes]);

// -------------------- MAIN LAYOUT --------------------
const MyLayout: React.FC = () => {
  const [open, setOpen] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  const { userInfo } = useAuthStore();


  const allowedRoutes = useMemo(() => {
    if (!userInfo) return [];
    return routes.filter((r) => checkRightAccess(r.type, userInfo));
  }, [userInfo]);


  const {
    token: { colorBgContainer },
  } = theme.useToken();

  return (
    <Layout className="min-h-screen bg-white">
      <Layout.Sider
        collapsible
        width={340}
        collapsed={collapsed}
        trigger={null}
        className="bg-primary rounded-r-3xl lg:block hidden"
      >
        <div
          className={`p-4 pt-6 flex items-center justify-center mb-2 max-h-[80px] border-b border-primary ${
            collapsed ? "justify-center" : "justify-start"
          }`}
        >
          <Link to="/">
            <img
              src="/svg_logo.svg"
              alt="Logo"
              className="w-44 h-20 object-contain"
            />
          </Link>
        </div>

        <SidebarMenu collapsed={collapsed} routes={allowedRoutes} />
      </Layout.Sider>

      <MobileMenuDrawer open={open} setOpen={setOpen} />

      <Layout className="bg-white">
        <Top
          {...{ collapsed, setCollapsed, showDrawer: () => setOpen(true) }}
        />

        <Layout.Content className="p-3 sm:p-5 text-black overflow-auto">
          <Routes>
            {newRoutes.map((v) =>
              v.component && v.url ? (
                <Route
                  path={v.url}
                  key={v.url}
                  element={React.createElement(v.component)}
                />
              ) : null
            )}

            {/* STATIC ROUTES */}
            <Route path="*" element={<Error404 />} />
            {/* <Route path="/profile" element={<AdminProfile />} /> */}
            <Route path="/users/details/:id" element={<UserDetails />} />
            <Route
              path="/accountant/create"
              element={<CreateAccountantFrom />}
            />
             <Route
              path="/filling-management/:id"
              element={<BucketDetails />}
            />
            <Route
              path="/accountant/edit/:id"
              element={<CreateAccountantFrom />}
            />
            <Route path="/form-fields/create" element={<CreateFormFields />} />
            <Route
              path="/form-fields/edit/:id"
              element={<CreateFormFields />}
            />
            <Route
              path="/accountant/details/:id"
              element={<AccountDetails />}
            />
            <Route
              path="/consultation/details/:id"
              element={<ConsultationDetails />}
            />
            <Route
              path="/documents/details/:id"
              element={<DocumentDetails />}
            />
            <Route path="/sub-admin/create" element={<SubAdminForm />} />
            <Route path="/sub-admin/edit/:id" element={<SubAdminForm />} />
            <Route path="/notification" element={<NotificationTable />} />
          </Routes>
        </Layout.Content>
      </Layout>
    </Layout>
  );
};

export default MyLayout;
